import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import $javelink_api from "../../api/services/javelink_api";

import {
    categories_created_at_after, categories_created_at_before,
    clients_created_at_after,
    clients_created_at_before,
    geo_created_at_after,
    geo_created_at_before
} from "../../utils/vars/dashboardParams";
import {created_at_after, created_at_before} from "../../pages/Authorized/Statistics/IOS/IOSClicksStats/IOSClicksStats";


export const fetchTopApps = createAsyncThunk(
    "dashboard/fetchTopApps",
    async (params) => {
        try {

            const newParams = new URLSearchParams();

            for (const [key, value] of params.entries()) {
                if (key === "app_created_at_after") {
                    newParams.append("created_at_after", value);
                } else if (key === "app_created_at_before") {
                    newParams.append("created_at_before", value);
                }
            }
            const response = await $javelink_api.get("/click-data/install-statistic/apps/",  {
                params: newParams
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

export const fetchTopGeos = createAsyncThunk(
    "dashboard/fetchTopGeos",
    async (params) => {
        try {

            const newParams = new URLSearchParams();

            for (const [key, value] of params.entries()) {
                if (key === geo_created_at_after) {
                    newParams.append(created_at_after, value);
                } else if (key === geo_created_at_before) {
                    newParams.append(created_at_before, value);
                }
            }
            const response = await $javelink_api.get("/click-data/install-statistic/geos/",  {
                params: newParams
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

export const fetchTopClients = createAsyncThunk(
    "dashboard/fetchTopClients",
    async (params) => {
        try {

            const newParams = new URLSearchParams();

            for (const [key, value] of params.entries()) {
                if (key === clients_created_at_after) {
                    newParams.append(created_at_after, value);
                } else if (key === clients_created_at_before) {
                    newParams.append(created_at_before, value);
                }
            }
            const response = await $javelink_api.get("/click-data/install-statistic/clients/",  {
                params: newParams
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

export const fetchTopCategories = createAsyncThunk(
    "dashboard/fetchTopCategories",
    async (params) => {
        try {

            const newParams = new URLSearchParams();

            for (const [key, value] of params.entries()) {
                if (key === categories_created_at_after) {
                    newParams.append(created_at_after, value);
                } else if (key === categories_created_at_before) {
                    newParams.append(created_at_before, value);
                }
            }
            const response = await $javelink_api.get("/click-data/install-statistic/categories/",  {
                params: newParams
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);


const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: {
        topAppsPending: false,
        topAppsList: [],
        topGeosList: [],
        topGeosPending: false,
        topClientsList: [],
        topClientsPending: false,
        topCategoriesList: [],
        topCategoriesPending: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTopCategories.pending, (state) => {
                state.topCategoriesPending = true;
                state.topCategoriesList = [];
            })
            .addCase(fetchTopCategories.fulfilled, (state, { payload }) => {
                state.topCategoriesList = payload?.results;
                state.topCategoriesPending = false;
            })
            .addCase(fetchTopCategories.rejected, (state) => {
                state.topCategoriesPending = false;
                state.topCategoriesList = [];
            })
            .addCase(fetchTopClients.pending, (state) => {
                state.topClientsPending = true;
                state.topClientsList = [];
            })
            .addCase(fetchTopClients.fulfilled, (state, { payload }) => {
                state.topClientsList = payload;
                state.topClientsPending = false;
            })
            .addCase(fetchTopClients.rejected, (state) => {
                state.topClientsPending = false;
                state.topClientsList = [];
            })
            .addCase(fetchTopGeos.pending, (state) => {
                state.topGeosPending = true;
                state.topGeosList = [];
            })
            .addCase(fetchTopGeos.fulfilled, (state, { payload }) => {
                state.topGeosList = payload;
                state.topGeosPending = false;
            })
            .addCase(fetchTopGeos.rejected, (state) => {
                state.topGeosPending = false;
                state.topGeosList = [];
            })
            .addCase(fetchTopApps.pending, (state) => {
                state.topAppsPending = true;
                state.topAppsList = [];
            })
            .addCase(fetchTopApps.fulfilled, (state, { payload }) => {
                state.topAppsList = payload?.results;
                state.topAppsPending = false;
            })
            .addCase(fetchTopApps.rejected, (state) => {
                state.topAppsPending = false;
                state.topAppsList = [];
            })
            //
            // .addCase(fetchAppListWithSearch.pending, (state) => {
            //     state.appListLoading = true;
            //     state.appList = [];
            // })
            // .addCase(fetchAppListWithSearch.fulfilled, (state, { payload }) => {
            //     state.appList = payload;
            //     state.appListLoading = false;
            // })
            // .addCase(fetchAppListWithSearch.rejected, (state) => {
            //     state.appListLoading = false;
            //     state.appList = [];
            // })
    },
});

// export const { } = applicationSlice.actions;

export default dashboardSlice.reducer;

export const dashboardSelector = (state) => state.dashboard;